module.exports = __webpack_public_path__ + "media/images/online_ordering_settings_images/half_banner-4ff80f17e4460005de52027f5157158b.png";